// eslint-disable-next-line import/prefer-default-export
export class EditEmployeeGroupStrategy {
  constructor(store) {
    this.store = store;
  }

  save(form) {
    return this.store.dispatch('employeeGroup/editEmployeeGroup', form);
  }
}
